<div class="container-fluid">
  <app-content-tab-list
    activeTab="0"
    type="twitter"
    category="Twitter"
  ></app-content-tab-list>

  <div class="row section1 justify-content-between mt-4">
    <div class="col-12 col-md-auto">
      <div class="home-details">
        <h5 class="home-title">Golden Handles ({{ total | number: "1.0-0" }})</h5>
        <p class="home-subtitle">Manage notable Twitter/X accounts</p>
      </div>
    </div>
    <div class="col-12 col-md-auto golden-header-actions">
      <button
        class="btn btn-primary btn-dashboard golden-import-btn"
        (click)="openImportModal()"
        [disabled]="importing"
      >
        <i class="las la-file-import"></i
        >{{ importing ? "Importing..." : "Import Handles" }}
      </button>
      <button
        class="btn btn-primary btn-dashboard"
        (click)="openCreateModal()"
        [disabled]="importing"
      >
        <i class="las la-plus"></i>Add Handle
      </button>
    </div>
  </div>

  <div class="row section1">
    <div class="col-12">
      <div class="golden-filters">
        <div class="form-group mb-0">
          <label>Search</label>
          <input
            class="form-control"
            [(ngModel)]="filters.q"
            (keyup.enter)="applyFilters()"
            placeholder="Name, handle, domain or work"
          />
        </div>
        <div class="form-group mb-0">
          <label>Status</label>
          <select class="form-control" [(ngModel)]="filters.isActive">
            <option value="all">All</option>
            <option value="true">Active</option>
            <option value="false">Inactive</option>
          </select>
        </div>
        <div class="golden-filter-actions">
          <button
            class="btn btn-primary btn-dashboard golden-apply-filter"
            (click)="applyFilters()"
          >
            Apply filter
          </button>
          @if (filtersApplied) {
            <button class="btn golden-reset-filter" (click)="resetFilters()">
              Reset
            </button>
          }
        </div>
      </div>
    </div>
  </div>

  <div class="row section1">
    <div class="col-12">
      <div class="table-responsive applicants-details">
        <table class="table table-bordered user-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>X Handle</th>
              <th>Status</th>
              <th>X Tracking</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            @if (loading) {
              <tr>
                <td colspan="6" class="text-center py-5">Loading...</td>
              </tr>
            }
            @for (
              member of members
                | paginate
                  : {
                      itemsPerPage: perPage,
                      currentPage: page,
                      totalItems: total,
                      id: "twitter-golden-list",
                    };
              track member.id
            ) {
              <tr>
                <td
                  class="text-nowrap"
                  [attr.title]="(member.id || '').toUpperCase()"
                >
                  <span>{{ (member.id || "").slice(-6).toUpperCase() }}</span>
                  <i
                    (click)="handleCopyToClipboard(member.id)"
                    class="las la-copy la-lg pointer copy-icon"
                  ></i>
                </td>
                <td>
                  <div class="golden-member-name">
                    <img
                      class="golden-profile-picture"
                      [src]="
                        member.meta_data?.profilePicture || profilePlaceholder
                      "
                      [alt]="member.name + ' profile picture'"
                      (error)="onProfileImageError($event)"
                    />
                    <span class="golden-member-label">
                      <span class="font-weight-bold">{{ member.name }}</span>
                      @if (
                        member.meta_data?.isBlueVerified ||
                        member.meta_data?.isVerified
                      ) {
                        <svg
                          class="twitter-verified"
                          viewBox="0 0 22 22"
                          aria-label="Verified account"
                          role="img"
                        >
                          <path d="M20.396 11c-.018-.646-.215-1.275-.57-1.816-.354-.54-.852-.972-1.438-1.246.223-.607.27-1.264.14-1.897-.131-.634-.437-1.218-.882-1.687-.47-.445-1.053-.75-1.687-.882-.633-.13-1.29-.083-1.897.14-.273-.587-.704-1.086-1.245-1.44S11.647 1.62 11 1.604c-.646.017-1.273.213-1.813.568s-.969.854-1.24 1.44c-.608-.223-1.267-.272-1.902-.14-.635.13-1.22.436-1.69.882-.445.47-.749 1.055-.878 1.688-.13.633-.08 1.29.144 1.896-.587.274-1.087.705-1.443 1.245-.356.54-.555 1.17-.574 1.817.02.647.218 1.276.574 1.817.356.54.856.972 1.443 1.245-.224.606-.274 1.263-.144 1.896.13.634.433 1.218.877 1.688.47.443 1.054.747 1.687.878.633.132 1.29.084 1.897-.136.274.586.705 1.084 1.246 1.439.54.354 1.17.551 1.816.569.647-.016 1.276-.213 1.817-.567s.972-.854 1.245-1.44c.604.239 1.266.296 1.903.164.636-.132 1.22-.447 1.68-.907.46-.46.776-1.044.908-1.681s.075-1.299-.165-1.903c.586-.274 1.084-.705 1.439-1.246.354-.54.551-1.17.569-1.816zM9.662 14.85l-3.429-3.428 1.293-1.302 2.072 2.072 4.4-4.794 1.347 1.246z"></path>
                        </svg>
                      }
                    </span>
                  </div>
                </td>
                <td>
                  <a
                    [href]="member.xUrl"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    @{{ member.xHandle }}
                    <i class="las la-external-link-alt"></i>
                  </a>
                </td>
                <td>
                  <span
                    class="golden-status"
                    [class.inactive]="!member.isActive"
                  >
                    {{ member.isActive ? "Active" : "Inactive" }}
                  </span>
                </td>
                <td>
                  <span
                    class="golden-status"
                    [class.inactive]="member.filterRule?.status !== 'active'"
                    [attr.title]="member.filterRule?.error || ''"
                  >
                    {{ member.filterRule?.status || "Pending" | titlecase }}
                  </span>
                </td>
                <td class="action">
                  <div class="dropdown">
                    <button
                      type="button"
                      class="btn header-item waves-effect btn-dropdown"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <span class="mr-3 text-primary py-2 text-nowrap">
                        View actions
                        <i class="las mb-1 la-angle-down align-middle mr-0"></i>
                      </span>
                    </button>
                    <div
                      class="dropdown-menu dropdown-menu-right animate slideIn side-menu-dropdown py-0 rounded-1"
                    >
                      <button
                        type="button"
                        class="dropdown-item text-primary border-bottom py-2 text-nowrap"
                        (click)="openViewModal(member)"
                      >
                        <i class="las la-eye mb-1 la-lg align-middle mr-0"></i>
                        View
                      </button>
                      <button
                        type="button"
                        class="dropdown-item text-info border-bottom py-2 text-nowrap"
                        (click)="openEditModal(member)"
                      >
                        <i class="las la-edit mb-1 la-lg align-middle mr-0"></i>
                        Edit
                      </button>
                      @if (member.isActive) {
                        <button
                          type="button"
                          class="dropdown-item text-warning border-bottom py-2 text-nowrap"
                          (click)="deactivate(member)"
                        >
                          <i
                            class="las la-ban mb-1 la-lg align-middle mr-0"
                          ></i>
                          Deactivate
                        </button>
                      } @else {
                        <button
                          type="button"
                          class="dropdown-item text-success border-bottom py-2 text-nowrap"
                          (click)="reactivate(member)"
                        >
                          <i
                            class="las la-check-circle mb-1 la-lg align-middle mr-0"
                          ></i>
                          Activate
                        </button>
                      }
                      <button
                        type="button"
                        class="dropdown-item text-danger py-2 text-nowrap"
                        (click)="deleteMember(member)"
                      >
                        <i
                          class="las la-trash mb-1 la-lg align-middle mr-0"
                        ></i>
                        Delete
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
            }
            @if (!loading && !members.length) {
              <tr>
                <td colspan="6" class="text-center py-5">
                  No golden handles found
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      <div class="float-right mt-3" [class.d-none]="total <= perPage">
        <pagination-controls
          id="twitter-golden-list"
          (pageChange)="pageChange($event)"
        ></pagination-controls>
      </div>
    </div>
  </div>
</div>

@if (showImportModal) {
  <div class="modal fade show golden-modal" tabindex="-1" role="dialog" [ngStyle]="{ display: 'block' }" (click)="closeImportModal()">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document" (click)="$event.stopPropagation()">
      <div class="modal-content golden-modal-content">
        <div class="modal-header golden-modal-header">
          <div>
            <h5 class="modal-title golden-modal-title">Import Handles</h5>
            <p class="golden-modal-subtitle mb-0">Import Twitter/X handles from your file</p>
          </div>
          <button type="button" class="close golden-close-btn" aria-label="Close" (click)="closeImportModal()"><span aria-hidden="true">&times;</span></button>
        </div>
        <div class="modal-body golden-modal-body">
          @if (!importReport) {
            <div class="golden-import-rules">
              <strong>Read through the rules before uploading your file.</strong>
              <ul>
                <li>The file format should be <strong>.csv</strong> and no larger than 2 MB.</li>
                <li>Required columns: <strong>name, xHandle, xUrl</strong>.</li>
                <li>Optional columns: <strong>primaryDomain, notableBooksWork</strong>.</li>
                <li>The X URL must match the handle, and each handle must be unique.</li>
                <li>Each account will be verified before it is added.</li>
                <li>Unverified accounts will not be added, and duplicate handles will be skipped.</li>
                <li>If you still have questions, You can <a [href]="importSampleUrl" download target="_blank" rel="noopener">Download</a> the sample file from here.</li>
              </ul>
            </div>
            <label class="golden-label mt-4">Import from CSV file <span>*</span></label>
            <div class="golden-import-picker">
              <input #importInput type="file" accept=".csv,text/csv" class="form-control" (change)="selectImportFile($event)" />
              <button class="btn btn-outline-primary" type="button" (click)="viewImportFile()" [disabled]="!importFile">View uploaded file</button>
              <button class="btn btn-primary btn-dashboard ml-0" type="button" (click)="importHandles()" [disabled]="!importFile || importing">{{ importing ? "Uploading..." : "Upload file" }}</button>
            </div>
          } @else {
            <div class="golden-import-summary">
              <div class="success"><strong>{{ importReport.imported || 0 | number: "1.0-0" }}</strong><span>Successful</span></div>
              <div class="failed"><strong>{{ importReport.failed || 0 | number: "1.0-0" }}</strong><span>Failed</span></div>
              <div><strong>{{ importReport.totalRows || 0 | number: "1.0-0" }}</strong><span>Total rows</span></div>
            </div>
            @if (importReport.failedRows?.length) {
              <h6 class="mt-4">Failed rows</h6>
              <div class="table-responsive golden-import-failures">
                <table class="table table-bordered"><thead><tr><th>Row</th><th>Handle</th><th>Why it failed</th></tr></thead>
                  <tbody>@for (failure of importReport.failedRows; track $index) {<tr><td>{{ failure.row || "—" }}</td><td><strong>{{ failure.handle || "—" }}</strong>@if (failure.name) {<small class="d-block text-muted">{{ failure.name }}</small>}</td><td>{{ failure.message }}</td></tr>}</tbody>
                </table>
              </div>
            } @else {
              <div class="alert alert-success mt-4 mb-0">All handles were imported successfully.</div>
            }
          }
        </div>
        <div class="modal-footer golden-modal-footer">
          <button class="btn btn-outline-secondary" (click)="closeImportModal()" [disabled]="importing">{{ importReport ? "Close" : "Cancel" }}</button>
        </div>
      </div>
    </div>
  </div>
}

@if (showModal) {
  <div
    class="modal fade show golden-modal"
    tabindex="-1"
    role="dialog"
    [ngStyle]="{ display: 'block' }"
    (click)="closeModal()"
  >
    <div
      class="modal-dialog modal-lg modal-dialog-centered"
      role="document"
      (click)="$event.stopPropagation()"
    >
      <div class="modal-content golden-modal-content">
        <div class="modal-header golden-modal-header">
          <div>
            <h5 class="modal-title golden-modal-title">
              {{ isEditMode ? "Edit" : "Add" }} Golden Handle
            </h5>
            <p class="golden-modal-subtitle mb-0">
              Add a notable Twitter/X account to the curated handles list.
            </p>
          </div>
          <button
            type="button"
            class="close golden-close-btn"
            aria-label="Close"
            (click)="closeModal()"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body golden-modal-body">
          <div class="row">
            <div class="col-12 col-md-6 form-group">
              <label class="golden-label">Name <span>*</span></label>
              <input
                class="form-control"
                [(ngModel)]="form.name"
                maxlength="150"
              />
            </div>
            <div class="col-12 col-md-6 form-group">
              <label class="golden-label">X Handle <span>*</span></label>
              <input
                class="form-control"
                [ngModel]="form.xHandle"
                (ngModelChange)="onHandleChange($event)"
                placeholder="@handle"
              />
            </div>
            <div class="col-12 form-group">
              <label class="golden-label">X URL <span>*</span></label>
              <input
                type="url"
                class="form-control"
                [(ngModel)]="form.xUrl"
                placeholder="https://x.com/handle"
              />
            </div>
            <div class="col-12 form-group">
              <label class="golden-label">Primary Domain</label>
              <input
                class="form-control"
                [(ngModel)]="form.primaryDomain"
                maxlength="200"
              />
            </div>
            <div class="col-12 form-group">
              <label class="golden-label">Notable Books / Work</label>
              <textarea
                class="form-control"
                rows="4"
                [(ngModel)]="form.notableBooksWork"
                maxlength="2000"
              ></textarea>
            </div>
            @if (isEditMode) {
              <div class="col-12 form-group mb-0">
                <label class="d-flex align-items-center mb-0">
                  <input
                    type="checkbox"
                    class="mr-2"
                    [(ngModel)]="form.isActive"
                  />
                  Active
                </label>
              </div>
            }
          </div>
        </div>
        <div class="modal-footer golden-modal-footer">
          <button
            class="btn btn-outline-secondary"
            (click)="closeModal()"
            [disabled]="saving"
          >
            Cancel
          </button>
          <button
            class="btn btn-primary btn-dashboard ml-0"
            (click)="save()"
            [disabled]="!isFormValid() || saving"
          >
            {{ saving ? "Saving..." : "Save Handle" }}
          </button>
        </div>
      </div>
    </div>
  </div>
}

@if (showViewModal && selectedMember) {
  <app-golden-handle-modal [goldenHandle]="selectedMember" (closed)="closeViewModal()"></app-golden-handle-modal>
}

@if (false) {
  <div
    class="modal fade show golden-modal"
    tabindex="-1"
    role="dialog"
    [ngStyle]="{ display: 'block' }"
    (click)="closeViewModal()"
  >
    <div
      class="modal-dialog modal-lg modal-dialog-centered"
      role="document"
      (click)="$event.stopPropagation()"
    >
      <div class="modal-content golden-modal-content twitter-profile-modal">
        <div class="twitter-profile-topbar">
          <div class="twitter-topbar-title">
            <strong class="twitter-topbar-name">
              {{ selectedMember.meta_data?.name || selectedMember.name }}
              @if (
                selectedMember.meta_data?.isBlueVerified ||
                selectedMember.meta_data?.isVerified
              ) {
                <svg
                  class="twitter-verified"
                  viewBox="0 0 22 22"
                  aria-label="Verified account"
                  role="img"
                >
                  <path d="M20.396 11c-.018-.646-.215-1.275-.57-1.816-.354-.54-.852-.972-1.438-1.246.223-.607.27-1.264.14-1.897-.131-.634-.437-1.218-.882-1.687-.47-.445-1.053-.75-1.687-.882-.633-.13-1.29-.083-1.897.14-.273-.587-.704-1.086-1.245-1.44S11.647 1.62 11 1.604c-.646.017-1.273.213-1.813.568s-.969.854-1.24 1.44c-.608-.223-1.267-.272-1.902-.14-.635.13-1.22.436-1.69.882-.445.47-.749 1.055-.878 1.688-.13.633-.08 1.29.144 1.896-.587.274-1.087.705-1.443 1.245-.356.54-.555 1.17-.574 1.817.02.647.218 1.276.574 1.817.356.54.856.972 1.443 1.245-.224.606-.274 1.263-.144 1.896.13.634.433 1.218.877 1.688.47.443 1.054.747 1.687.878.633.132 1.29.084 1.897-.136.274.586.705 1.084 1.246 1.439.54.354 1.17.551 1.816.569.647-.016 1.276-.213 1.817-.567s.972-.854 1.245-1.44c.604.239 1.266.296 1.903.164.636-.132 1.22-.447 1.68-.907.46-.46.776-1.044.908-1.681s.075-1.299-.165-1.903c.586-.274 1.084-.705 1.439-1.246.354-.54.551-1.17.569-1.816zM9.662 14.85l-3.429-3.428 1.293-1.302 2.072 2.072 4.4-4.794 1.347 1.246z"></path>
                </svg>
              }
            </strong>
            <span
              >{{
                compactNumber(selectedMember.meta_data?.statusesCount)
              }}
              posts</span
            >
          </div>
          <a
            class="twitter-open-profile"
            [href]="selectedMember.xUrl"
            target="_blank"
            rel="noopener noreferrer"
            title="Open on X"
          >
            <i class="las la-external-link-alt"></i>
          </a>
          <button
            type="button"
            class="twitter-back-btn"
            aria-label="Close"
            (click)="closeViewModal()"
          >
            <i class="las la-times"></i>
          </button>
        </div>
        <div
          class="twitter-cover"
          [style.background-image]="
            selectedMember.meta_data?.coverPicture
              ? 'url(' + selectedMember.meta_data.coverPicture + ')'
              : null
          "
        ></div>
        <div class="twitter-profile-summary">
          <img
            class="twitter-profile-avatar"
            [src]="
              highResolutionProfilePicture(
                selectedMember.meta_data?.profilePicture
              ) || profilePlaceholder
            "
            [alt]="selectedMember.name + ' profile picture'"
            (error)="onProfileImageError($event)"
          />
          <div class="twitter-profile-heading">
            <h4>
              {{ selectedMember.meta_data?.name || selectedMember.name }}
              @if (
                selectedMember.meta_data?.isBlueVerified ||
                selectedMember.meta_data?.isVerified
              ) {
                <svg
                  class="twitter-verified"
                  viewBox="0 0 22 22"
                  aria-label="Verified account"
                  role="img"
                >
                  <path d="M20.396 11c-.018-.646-.215-1.275-.57-1.816-.354-.54-.852-.972-1.438-1.246.223-.607.27-1.264.14-1.897-.131-.634-.437-1.218-.882-1.687-.47-.445-1.053-.75-1.687-.882-.633-.13-1.29-.083-1.897.14-.273-.587-.704-1.086-1.245-1.44S11.647 1.62 11 1.604c-.646.017-1.273.213-1.813.568s-.969.854-1.24 1.44c-.608-.223-1.267-.272-1.902-.14-.635.13-1.22.436-1.69.882-.445.47-.749 1.055-.878 1.688-.13.633-.08 1.29.144 1.896-.587.274-1.087.705-1.443 1.245-.356.54-.555 1.17-.574 1.817.02.647.218 1.276.574 1.817.356.54.856.972 1.443 1.245-.224.606-.274 1.263-.144 1.896.13.634.433 1.218.877 1.688.47.443 1.054.747 1.687.878.633.132 1.29.084 1.897-.136.274.586.705 1.084 1.246 1.439.54.354 1.17.551 1.816.569.647-.016 1.276-.213 1.817-.567s.972-.854 1.245-1.44c.604.239 1.266.296 1.903.164.636-.132 1.22-.447 1.68-.907.46-.46.776-1.044.908-1.681s.075-1.299-.165-1.903c.586-.274 1.084-.705 1.439-1.246.354-.54.551-1.17.569-1.816zM9.662 14.85l-3.429-3.428 1.293-1.302 2.072 2.072 4.4-4.794 1.347 1.246z"></path>
                </svg>
              }
            </h4>
            <a
              [href]="selectedMember.xUrl"
              target="_blank"
              rel="noopener noreferrer"
            >
              @{{
                selectedMember.meta_data?.userName || selectedMember.xHandle
              }}
            </a>
          </div>
          @if (selectedMember.meta_data?.description) {
            <p class="twitter-profile-description">
              {{ selectedMember.meta_data.description }}
            </p>
          }
          <div class="twitter-profile-facts">
            @if (selectedMember.meta_data?.location) {
              <span
                ><i class="las la-map-marker"></i
                >{{ selectedMember.meta_data.location }}</span
              >
            }
            @if (profileWebsite(selectedMember.meta_data)) {
              <a
                [href]="profileWebsite(selectedMember.meta_data)"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i class="las la-link"></i
                >{{ profileWebsite(selectedMember.meta_data) }}
              </a>
            }
            @if (selectedMember.meta_data?.createdAt) {
              <span
                ><i class="las la-calendar"></i>Joined
                {{
                  selectedMember.meta_data.createdAt | date: "MMM yyyy"
                }}</span
              >
            }
          </div>
          <div class="twitter-profile-stats">
            <span
              ><strong>{{
                compactNumber(selectedMember.meta_data?.following)
              }}</strong>
              Following</span
            >
            <span
              ><strong>{{
                compactNumber(selectedMember.meta_data?.followers)
              }}</strong>
              Followers</span
            >
          </div>
        </div>
        <div class="twitter-profile-tabs">
          <span class="active">Posts</span>
        </div>
        <div class="twitter-post-list">
          @if (memberPostsLoading) {
            <div class="twitter-post-state">Loading posts...</div>
          } @else {
            @for (post of memberPosts; track post._id) {
              <article class="twitter-post">
                <img
                  class="twitter-post-avatar"
                  [src]="
                    post.author?.profilePicture ||
                    selectedMember.meta_data?.profilePicture ||
                    profilePlaceholder
                  "
                  [alt]="selectedMember.name + ' profile picture'"
                  (error)="onProfileImageError($event)"
                />
                <div class="twitter-post-content">
                  <div class="twitter-post-heading">
                    <strong>{{ post.author?.name || selectedMember.name }}</strong>
                    <span>@{{ post.author?.userName || selectedMember.xHandle }}</span>
                    <span>&middot;</span>
                    <span>{{ post.publishedAt | date: "MMM d, y" }}</span>
                  </div>
                  <p
                    class="twitter-post-text"
                    [attr.data-post-text-key]="post._id"
                    [class.expanded]="expandedPostText.has(post._id)"
                  >{{ post.text }}</p>
                  @if (isPostTextTruncated(post._id)) {
                    <button class="twitter-post-view-more" type="button" (click)="togglePostText(post._id)">
                      {{ expandedPostText.has(post._id) ? "View less" : "View more" }}
                    </button>
                  }
                  @if (post.media?.length) {
                    <div class="twitter-post-media" [class.multiple]="post.media.length > 1">
                      @for (media of post.media; track media.imageUrl) {
                        @if (media.videoUrl) {
                          <video controls preload="metadata" [poster]="media.imageUrl">
                            <source [src]="media.videoUrl" type="video/mp4" />
                          </video>
                        } @else {
                          <img [src]="media.imageUrl" alt="Post media" loading="lazy" />
                        }
                      }
                    </div>
                  }
                  @if (post.embeddedPost) {
                    <div
                      class="twitter-embedded-post"
                    >
                      <small>{{ post.embeddedPostType }}</small>
                      <div class="twitter-embedded-heading">
                        <strong>{{ post.embeddedPost.author?.name }}</strong>
                        <span>@{{ post.embeddedPost.author?.userName }}</span>
                        <a
                          [href]="post.embeddedPost.url || post.url"
                          target="_blank"
                          rel="noopener noreferrer"
                          title="Open embedded post on X"
                        >
                          <i class="las la-external-link-alt"></i>
                        </a>
                      </div>
                      <p
                        class="twitter-post-text"
                        [attr.data-post-text-key]="post._id + '-embedded'"
                        [class.expanded]="expandedPostText.has(post._id + '-embedded')"
                      >{{ post.embeddedPost.text }}</p>
                      @if (isPostTextTruncated(post._id + '-embedded')) {
                        <button
                          class="twitter-post-view-more embedded"
                          type="button"
                          (click)="togglePostText(post._id + '-embedded')"
                        >
                          {{ expandedPostText.has(post._id + "-embedded") ? "View less" : "View more" }}
                        </button>
                      }
                      @if (post.embeddedPost.media?.length) {
                        <div class="twitter-post-media" [class.multiple]="post.embeddedPost.media.length > 1">
                          @for (media of post.embeddedPost.media; track media.imageUrl) {
                            @if (media.videoUrl) {
                              <video controls preload="metadata" [poster]="media.imageUrl">
                                <source [src]="media.videoUrl" type="video/mp4" />
                              </video>
                            } @else {
                              <img [src]="media.imageUrl" alt="Embedded post media" loading="lazy" />
                            }
                          }
                        </div>
                      }
                    </div>
                  }
                  <div class="twitter-post-metrics">
                    <span><i class="las la-comment"></i>{{ compactNumber(post.metrics?.replies) }}</span>
                    <span><i class="las la-retweet"></i>{{ compactNumber(post.metrics?.reposts) }}</span>
                    <span><i class="las la-heart"></i>{{ compactNumber(post.metrics?.likes) }}</span>
                    <span><i class="las la-eye"></i>{{ compactNumber(post.metrics?.views) }}</span>
                    <a [href]="post.url" target="_blank" rel="noopener noreferrer" title="Open post on X">
                      <i class="las la-external-link-alt"></i>
                    </a>
                  </div>
                </div>
              </article>
            }
            @if (!memberPosts.length) {
              <div class="twitter-post-state">No collected posts found.</div>
            }
          }
        </div>
      </div>
    </div>
  </div>
}
